/*
 * Copyright (c) 2008-2019 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
 * This is CONFIDENTIAL code. Use is subject to license terms.
 */

/** the logger used to log the system **/
var log;
var logping;

var log4javascript_disabled = true;
var log4javascript_default_log_level = "info";

/* logging */

function loadLog4JLib(startAfterLoad) {
	log4javascript_disabled = false;
	LazyLoad.js("js/lib/log4javascript.js", function () {
		log4javascript.setShowStackTraces(true);
		log = log4javascript.getLogger("MAIN");

		var log4JSlogLevelMap = {
			"all": log4javascript.Level.ALL,
			"debug": log4javascript.Level.DEBUG,
			"error": log4javascript.Level.ERROR,
			"fatal": log4javascript.Level.FATAL,
			"info": log4javascript.Level.INFO,
			"trace": log4javascript.Level.TRACE,
			"warn": log4javascript.Level.WARN,
			"true": log4javascript.Level.ALL,
			"false": log4javascript.Level.FATAL
		};

		var level = log4JSlogLevelMap[log4javascript_default_log_level.toLowerCase()] || log4javascript.Level.ALL;
		log.setLevel(level);

		//seperate logger for the ping-handshake
		if (pingLogger) {
			logping = log4javascript.getLogger("NETWORK");
			logping.setLevel(log4javascript.Level.ALL);
		} else {
			logping = log4javascript.getNullLogger();
		}

		// initialize the appenders

		// it's helpful to also route messages to the console
		addConsoleLogAppender();

		// from now on also start remote logging per default if logging is enabled
		addAjaxLogAppender();

		if (getConfigParameter('openDebugWindow')) {
			addDebugWindowLogAppender()
		}
		if (typeof startAfterLoad === "function") {
			startAfterLoad(log, logping);
		}
	});
}

var log4javascript_consoleAppender;
function addConsoleLogAppender() {
  log4javascript_consoleAppender = new log4javascript.BrowserConsoleAppender();

	// see http://log4javascript.org/docs/manual.html#patternlayout
  // log4javascript_consoleAppender.setLayout(new log4javascript.PatternLayout("%d{HH:mm:ss,SSS} %-5p - %m{2}%n"));
  // just include time and no date as the console is quite transient
  var pattern = "%d{HH:mm:ss,SSS} "
    // and now pimp the console log appender a bit to include station type and client ID
  if (typeof getStationType === "function") {
    pattern += getStationType().substr(0, 2) + "-";
  }
  if (typeof clientId === "string") {
    pattern += clientId.substr(0, 4);
  }
  pattern += " %-5p - %m{2}%n";
  log4javascript_consoleAppender.setLayout(
    new log4javascript.PatternLayout(pattern));

  // log4javascript_consoleAppender.setThreshold(log4javascript.Level.WARN); // better use default level
	log4javascript.getRootLogger().addAppender(log4javascript_consoleAppender);
}

function addDebugWindowLogAppender() {
	var popUpAppender = new log4javascript.PopUpAppender(true);
	var popUpLayout = new log4javascript.PatternLayout("%d{yyyy-MM-dd HH:mm:ss,SSS} %-5p - %m{2}%n");
	popUpAppender.setLayout(popUpLayout);
	log4javascript.getRootLogger().addAppender(popUpAppender);
}

var log_ajaxAppender = null;

function addAjaxLogAppender() {
	if (!baseURL) { return; } // baseURL is not yet set!
	if (log_ajaxAppender) {
		log4javascript.getRootLogger().removeAppender(log_ajaxAppender);
	}
	log.info("--- clientInfo: " + JSON.stringify(clientInfo));
	var myConnectionId = "no-id-yet";
	if (typeof clientInfo === "object" && typeof clientInfo.connectionId !== "undefined") {
		myConnectionId = clientInfo.connectionId;
	}
	var logUrl = baseURL + "/jslog?clientId=" + myConnectionId;
	log_ajaxAppender = new log4javascript.AjaxAppender(logUrl);
	var xmlLayout = new log4javascript.XmlLayout();
	log_ajaxAppender.setLayout(xmlLayout);
	log_ajaxAppender.setBatchSize(5);
	log4javascript.getRootLogger().addAppender(log_ajaxAppender);
	log.info("started remote logging to ", logUrl);
}


function remoteLogging(actionRef, args) {
	var stop = args.stop != null;
	log4javascript_default_log_level = args.logLevel;
	openDebugWindow = args.debugWindow != null; // set the global variable

	if (stop) {
		log.info("stop remote Logging");
		log4javascript.getRootLogger().removeAppender(log_ajaxAppender);
		log_ajaxAppender = null;
	} else {
		loadLog4JLib(function () { log.debug("remote logging started")});
	}
}

/**
 * set or remove the localStorage key to start the wrapper's remote logging (if supported)
 * @param actionRef
 * @param args
 */
function wrapperRemoteLogging(actionRef, args) {
	if (typeof Wrapper.updateConfig !== "function") {
		log.warn("wrapperRemoteLogging() ignored, Wrapper does not support updateConfig()");
		return;
	}
	var stop = args.stop != null;
	if (stop) {
		Wrapper.updateConfig({remoteLoggingURL: null});
	} else {
		Wrapper.updateConfig({remoteLoggingURL: baseURL + "/jslog?clientId=Wrapper_" + clientInfo.connectionId});
	}
}

/**
 * notifyProgrammingError always writes error messages also to console.error()
 * This does this directly, not via the logger, as it should also work when logging is not enabled.
 *
 * This function should be used in all cases of programming errors / error in event material etc
 * That really should be fixed (but not for error that occur in dynamic situations during events)
 *
 * @param msg
 * @param e optional: Exception
 */
function notifyProgrammingError(msg, e) {
	logError(msg, e);
	debugger; // halt execution if running in debugger
	// NOTE: the debugger statement causes a warning when a JS file is minimized
	// that is why the notifyProgrammingError() is placed here in HelperFunctions.js, as this is NOT minimized, but kept as it is
}

/**
 * safe error logging for startup before log4js is loaded
 */
function logError() {
	if (typeof log === 'object' && typeof log.error === 'function') { return log.error.apply(log, arguments); }
	if (typeof console === 'object' && typeof console.error === 'function') { console.error.apply(console, arguments); }
}

/**
 * safe warning logging for startup before log4js is loaded
 */
function logWarn() {
	if (typeof log === 'object' && typeof log.warn === 'function') { return log.warn.apply(log, arguments); }
	if (typeof console === 'object' && typeof console.warn === 'function') { console.warn.apply(console, arguments); }
}

/**
 * safe info logging for startup before log4js is loaded
 */
function logInfo() {
	if (typeof log === 'object' && typeof log.info === 'function') { return log.info.apply(log, arguments); }
	if (typeof console === 'object' && typeof console.info === 'function') { console.info.apply(console, arguments); }
}

/**
 * safe debug logging for startup before log4js is loaded
 */
function logDebug() {
	if (typeof log === 'object' && typeof log.debug === 'function') { return log.debug.apply(log, arguments); }
	if (typeof console === 'object' && typeof console.debug === 'function') { console.debug.apply(console, arguments); }
}

/**
 * safe trace logging for startup before log4js is loaded
 */
function logTrace() {
	if (typeof log === 'object' && typeof log.trace === 'function') { return log.trace.apply(log, arguments); }
	if (typeof console === 'object' && typeof console.debug === 'function') { console.debug.apply(console, arguments); }
}


// inform if uncaught exceptions occur, especially if there is a syntax error in custom_tools.js etc
window.onerror = function (msg, url, line) {
	notifyProgrammingError(msg + " in " + url + ":" + line);
};

if (typeof module === "object" && typeof module.exports === "object") {
	module.exports.notifyProgrammingError = notifyProgrammingError;
	module.exports.logError = logError;
	module.exports.logWarn = logWarn;
	module.exports.logInfo = logInfo;
	module.exports.logDebug = logDebug;
	module.exports.logTrace = logTrace;
	module.exports.addConsoleLogAppender = addConsoleLogAppender;
}
